/**
 * Gives a declared omni or spot light the shadow that draws into the positional shadow atlas, in
 * place of the one three built with the light. An area light's component gives it its own.
 */
import * as THREE from 'three';
import { AtlasOmniShadow } from './atlasOmniShadow.js';
import { AtlasSpotShadow } from './atlasSpotShadow.js';
import { isAreaShadowLight } from './atlasAreaShadow.js';
/**
 * The light, its shadow replaced once. The new shadow copies what the light's component set on the
 * old one (`LightShadow.copy`), and react-three-fiber sets each later change on the light's current
 * shadow. The old shadow frees the map three built for it.
 */
export function adoptAtlasShadow(light) {
    if (isAreaShadowLight(light))
        return light;
    if (light instanceof THREE.SpotLight) {
        if (!(light.shadow instanceof AtlasSpotShadow))
            light.shadow = replaced(light.shadow, new AtlasSpotShadow());
        return light;
    }
    if (!(light.shadow instanceof AtlasOmniShadow))
        light.shadow = replaced(light.shadow, new AtlasOmniShadow());
    return light;
}
function replaced(old, next) {
    const map = next.map;
    next.copy(old);
    next.map = map;
    old.dispose();
    return next;
}
//# sourceMappingURL=adoptAtlasShadow.js.map